import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'
import { TrackingSchemaTypes } from '../../tracking'
import { useTracking } from 'react-tracking'

import CourseBanner from './components/CourseBanner'
import CourseModules from './components/CourseModules'
import HomeHeader from '../../components/HomeHeader'
import Footer from '../../components/Footer'

import { RootState } from '../../store/modules/rootReducer'

import ContentLoader from 'react-content-loader'
import { darkTheme, lightTheme } from '../../styles/themes'
import { changeRecentView } from '../../store/modules/recentView/action'
import { useGetCourseBasicInfo } from './hooks/use-get-course-basic-info'
import { WhiteBar, Wrapper } from './styles'

interface RouteParams {
  orderId: string
  courseId: string
}

type CourseProps = RouteComponentProps<RouteParams>

const Course: React.FC<CourseProps> = ({
  match: {
    params: { orderId, courseId },
  },
}) => {
  const dispatch = useDispatch()
  const { isDarkMode } = useSelector((state: RootState) => state.theme)
  const { trackEvent } = useTracking()

  const swrCourseBasicInfo = useGetCourseBasicInfo(courseId)
  const loading = swrCourseBasicInfo.isLoading
  const course = swrCourseBasicInfo.isLoading ? null : swrCourseBasicInfo.data

  useEffect(() => {
    if (course) {
      trackEvent({
        event: TrackingSchemaTypes.CourseImpression,
        properties: {
          Curso: course.name,
          Instituicao: course.publicTender,
          Carreira: course.career,
        },
      })
    }
  }, [course, trackEvent])

  useEffect(() => {
    dispatch(changeRecentView(courseId))
  }, [courseId, dispatch])

  const LoaderProps = {
    speed: 2,
    backgroundColor: isDarkMode ? '#222222' : '#bababa',
    foregroundColor: isDarkMode ? '#2b2b2b' : '#dedede',
  }

  return (
    <>
      <HomeHeader />
      <WhiteBar />
      <Wrapper
        style={{
          background: isDarkMode
            ? `rgb(${darkTheme.background.low})`
            : `rgb(${lightTheme.background.low})`,
        }}
      >
        {loading ? (
          <ContentLoader width={'100%'} height={80} viewBox={'0 0 100% 80'} {...LoaderProps}>
            <rect x="0" y="0" rx="6" ry="6" width="100%" height="80" />
          </ContentLoader>
        ) : (
          <>
            <CourseBanner course={course} />
            {course && (
              <CourseModules
                // eslint-disable-next-line react/no-children-prop
                children={course.children}
                courseId={courseId}
                orderId={orderId}
                course={course}
              />
            )}
          </>
        )}
      </Wrapper>
      <Footer />
    </>
  )
}

export default Course
